<!-- Footer -->
<footer class="d-flex flex-column flex-sm-row justify-content-center align-items-center gap-2 mt-4">
  <div class="d-flex flex-column flex-sm-row justify-content-center align-items-center gap-2">
    <p class="l-body">© {{ currentYear }} {{ "copy_right" | translate }}</p>
    <div class="d-flex justify-content-center align-items-center gap-2">
      <a class="l-body bold text-decoration-none" href="https://www.medullar.com">Medullar Solutions Inc.</a>
      |
      <a class="l-body bold text-decoration-none" href="https://www.medullar.com/us/en/privacy-policy">{{
        "privacy_policy" | translate
      }}</a>
    </div>
  </div>
</footer>
<!-- Footer -->
